import React from "react";
import { useTranslation } from "react-i18next";

interface BookingHeaderProps {
  step: number;
  timeLeft: number;
  onClose: () => void;
}

export const BookingHeader: React.FC<BookingHeaderProps> = ({
  step,
  timeLeft,
  onClose,
}) => {
  const { t } = useTranslation("common");

  return (
    <div className="relative rounded-t-3xl overflow-hidden p-6 sm:p-8 bg-stone-950 text-white border-b border-amber-500/20">
      {/* Visual background effect */}
      <div
        className="absolute inset-0 bg-cover bg-center opacity-30 transition-all duration-500"
        style={{
          backgroundImage: "url('/images/booking/header-bg.jpg')",
        }}
      />

      {/* Dark gradient mask over image */}
      <div className="absolute inset-0 bg-gradient-to-r from-stone-950 via-stone-950/80 to-transparent z-0" />

      <div className="relative z-10 flex items-center justify-between">
        <div>
          <span className="text-[10px] sm:text-xs font-semibold tracking-[0.25em] text-amber-400 uppercase block mb-1">
            {t("booking.restaurantSubheader", "R-ja.pl Restauracja")}
          </span>
          <h2 className="text-2xl sm:text-3xl font-serif font-light text-white tracking-wide">
            {t("booking.modalTitle", "Rezerwacja Stolika")}
          </h2>
        </div>

        <div className="flex items-center space-x-3">
          {step > 1 && (
            <div className="px-3 py-1.5 bg-black/50 backdrop-blur-md border border-amber-500/30 text-amber-300 text-xs font-mono rounded-full flex items-center space-x-1 shadow-inner">
              <span>⏱</span>
              <span>
                {Math.floor(timeLeft / 60)}:
                {(timeLeft % 60).toString().padStart(2, "0")}
              </span>
            </div>
          )}

          <button
            onClick={onClose}
            className="text-stone-400 hover:text-white transition w-9 h-9 rounded-full bg-white/5 hover:bg-white/10 flex items-center justify-center border border-white/10 backdrop-blur-sm cursor-pointer"
            aria-label={t("common.close", "Zamknij")}
          >
            ✕
          </button>
        </div>
      </div>
    </div>
  );
};
